import { useEffect } from "react";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { initLenis, scrollToId } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Portfolio } from "@/components/Portfolio";
import { Transformations } from "@/components/Transformations";
import { Experience } from "@/components/Experience";
import { Why } from "@/components/Why";
import { Testimonials } from "@/components/Testimonials";
import { Videos } from "@/components/Videos";
import { FAQ } from "@/components/FAQ";
import { Inquiry } from "@/components/Inquiry";
import { Instagram } from "@/components/Instagram";
import { Footer } from "@/components/Footer";
import { MobileCTA } from "@/components/MobileCTA";
import Courses from "@/components/Courses";

const Home = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash.slice(1)), 600);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [hash]);

  return (
    <main>
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Portfolio />
      <Transformations />
      <Experience />
      <Why />
      <Testimonials />
      <Videos />
      <FAQ />
      <Inquiry />
      <Instagram />
      <MobileCTA />
    </main>
  );
};

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <BrowserRouter>
      <div className="bg-[#FBF6EE] text-[#2A1F16] antialiased">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/courses" element={<Courses />} />
        </Routes>
        <Footer />
        <Toaster
          position="top-center"
          toastOptions={{ style: { background: "#2A1F16", color: "#FBF6EE", border: "1px solid #B8893B" } }}
        />
      </div>
    </BrowserRouter>
  );
}

export default App;
